<div class="discover-tab">
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading product usage…</p>
  </div>

  <div *ngIf="!isLoading && totalResults === 0" class="no-results">
    <mat-icon>search_off</mat-icon>
    <p>No product usage found</p>
    <button mat-button (click)="refreshData()"><mat-icon>refresh</mat-icon> Retry</button>
  </div>

  <div *ngIf="!isLoading && totalResults > 0" class="results-section">
    <div class="results-header">
      <h3>
        <mat-icon>analytics</mat-icon>
        Usage
        <span class="result-count">({{totalResults}} home{{totalResults !== 1 ? 's' : ''}})</span>
      </h3>
      <div class="header-actions">
        <button mat-button (click)="refreshData()" matTooltip="Refresh">
          <mat-icon>refresh</mat-icon> Refresh
        </button>
        <button mat-button color="accent" (click)="exportResults()">
          <mat-icon>download</mat-icon> Export CSV
        </button>
      </div>
    </div>

    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="full-width">
        <ng-container matColumnDef="homeName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Home</th>
          <td mat-cell *matCellDef="let record">{{record.homeName || '—'}}</td>
        </ng-container>

        <ng-container matColumnDef="companyName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th>
          <td mat-cell *matCellDef="let record">{{record.companyName || '—'}}</td>
        </ng-container>

        <ng-container matColumnDef="sightingCount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sightings</th>
          <td mat-cell *matCellDef="let record">
            <span class="stat-number">{{record.sightingCount || 0}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="replacementCount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Replacements</th>
          <td mat-cell *matCellDef="let record">
            <span class="stat-number">{{record.replacementCount || 0}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="hotspotCount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Hotspots</th>
          <td mat-cell *matCellDef="let record">
            <span class="stat-number">{{record.hotspotCount || 0}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="impressionCount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
              [matTooltip]="'Customer impressions in last ' + impressionWindowHours + 'h'">
            Impressions ({{impressionWindowHours}}h)
          </th>
          <td mat-cell *matCellDef="let record">
            <mat-spinner *ngIf="loadingImpressions" diameter="14"></mat-spinner>
            <span *ngIf="!loadingImpressions" class="stat-number"
                  [class.text-muted]="!record.impressionCount">{{record.impressionCount || 0}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="rooms">
          <th mat-header-cell *matHeaderCellDef>Rooms</th>
          <td mat-cell *matCellDef="let record">
            <span class="rooms-cell">{{getRoomsList(record)}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let record" class="actions-cell">
            <button mat-icon-button
                    (click)="viewHome(record); $event.stopPropagation()"
                    *ngIf="record.renderedOutputId"
                    matTooltip="Open home in SituVIEW">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <mat-icon class="expand-chevron" [class.expanded]="expandedRecord === record">
              expand_more
            </mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let record" [attr.colspan]="displayedColumns.length" class="expanded-cell">
            <div class="sighting-detail" [class.open]="expandedRecord === record">
              <div *ngIf="expandedRecord === record">
                <div *ngIf="isSightingsLoading(record)" class="sighting-loading">
                  <mat-spinner diameter="24"></mat-spinner>
                  <span>Loading sightings…</span>
                </div>
                <div *ngIf="!isSightingsLoading(record) && getSightings(record).length > 0" class="sighting-list">
                  <div class="sighting-row" *ngFor="let s of getSightings(record)">
                    <span class="sighting-room">{{s.roomName}}</span>
                    <span class="sighting-panorama">{{s.panoramaName}}</span>
                    <span class="sighting-distance">{{s.distance | number:'1.1-1'}}m</span>
                    <button mat-icon-button (click)="viewSighting(record, s)" matTooltip="Open in SituVIEW">
                      <mat-icon>open_in_new</mat-icon>
                    </button>
                  </div>
                </div>
                <div *ngIf="!isSightingsLoading(record) && getSightings(record).length === 0" class="sighting-empty">
                  No sightings
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let record; columns: displayedColumns;"
            class="record-row" [class.expanded]="expandedRecord === record"
            (click)="toggleExpand(record)"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
